import ApiBase from './api-base'
import { getCookie } from '@/modules/services/cookies'

class BeautyPerks extends ApiBase {
  headers = {
    'X-Site-Country': I18n.siteCountryLs.toUpperCase(),
    'X-Platform': getCookie('platform') || 'mobile_web',
    'X-App-Platform': getCookie('app_platform') || 'web_mobile',
    'X-App-Version': getCookie('app_version') || '1.0.0',
    'Content-Type': 'application/json'
  }

  async fetchPromotions ({
    pageSize = 50,
    pageNumber = 1
  } = {}) {
    const { data } = await this.client.get('/v2.5/beauty_perks/promotions', {
      params: {
        'page[size]': pageSize,
        'page[number]': pageNumber
      },
      headers: this.headers
    })

    return data
  }

  async fetchBeautyPerksDiscountCoupons ({
    pageSize = 30,
    pageNumber = 1
  } = {}) {
    const isMbpElixirEnabled = vueSupport.featureFlags.enableMbpElixir

    if (isMbpElixirEnabled) {
      const mockOffers = [
        {
          id: '3',
          type: 'offers',
          attributes: {
            code: 'GPAY181077141',
            'auto-apply': false,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['discount', 'gwp', 'free_shipping', 'points'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web', 'mweb'],
            mechanics: [
              {
                type: 'points-multiplier',
                value: 4
              },
              {
                type: 'flat-discount-amount',
                value: 50
              },
              {
                type: 'gwp',
                value: 'multi'
              }
            ]
          }
        },
        {
          id: '4',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'flat-discount-amount',
                value: 50
              },
              {
                type: 'gwp',
                value: 'single'
              },
              {
                type: 'free-shipping',
                value: 'true'
              }
            ]
          }
        },
        {
          id: '5',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'flat-discount-amount',
                value: 50
              }
            ]
          }
        },
        {
          id: '6',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'free-shipping',
                value: 'true'
              }
            ]
          }
        },
        {
          id: '7',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'fixed-point',
                value: 100
              }
            ]
          }
        },
        {
          id: '8',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'points-multiplier',
                value: 5
              }
            ]
          }
        },
        {
          id: '9',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'discount-percent',
                value: 10
              }
            ]
          }
        },
        {
          id: '10',
          type: 'offers',
          attributes: {
            'auto-apply': true,
            title: 'Better hair days await for you this summer',
            description:
              'Get a limited-edition comb with min. spend $100 online and in-stores.',
            instructions:
              'Copy and apply the promo code on the shopping bag.\n\n*Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders.',
            tnc:
              '- Offer valid only for Sephora Beauty Pass members only. Get %10 off with min. spend $50 on your orders./n- Offer valid once on sephora.com.au and/or Sephora Australia mobile app from 20 January 2022 (9am AEDT) to 20 February 2022 (11:59pm AEDT), while stocks last.',
            'shop-now-link': 'https://sephora.sg/brands/fenty-beauty',
            'image-url':
              'https://image-optimizer-reg.staging.sephora-asia.net/images/product_images/SephoraCollection_DrawstringSet_GWP_WEB_29de3d3aaeef5845b9ce672dc707e926353a0e15_1523785169.png',
            types: ['gwp', 'free_shipping'],
            'valid-till': '2022-11-12T23:59:59.999+08:00',
            platforms: ['app', 'web'],
            mechanics: [
              {
                type: 'unknown',
                value: 10
              }
            ]
          }
        }
      ]
      return { data: mockOffers, meta: { 'user-name': 'Sephora' } }
    } else {
      const { data } = await this.client.get(
        '/v2.5/beauty_perks/discount_coupons',
        {
          params: {
            'page[size]': pageSize,
            'page[number]': pageNumber
          },
          headers: this.headers
        }
      )
      return data
    }
  }

  async fetchBeautyPass () {
    const { data } = await this.client.get('/v2.5/beauty_perks/insider_gifts', {
      headers: this.headers
    })

    return data
  }
}

export default BeautyPerks
